import { Component } from "@angular/core";
import { ProdutoService } from "src/app/core/services/http/produto.service";
import { map } from "rxjs";
import { ProdutoFamiliaRequest } from "../../models/produto-familia.model";

@Component({
    selector: 'sub-grupo',
    templateUrl: './sub-grupo.component.html',
    styleUrls: ['./sub-grupo.component.scss'],
})
export class SubGrupoComponent {
    public subGrupo: string = '';

    public subGrupos$ = this._produtoService.getSubGrupos().pipe(map((l) => (l.success ? l.data : [])));

    constructor(
        private _produtoService: ProdutoService
    ) { }

    public adicionarSubGrupo() {
        const grupoRequest = new ProdutoFamiliaRequest();
        grupoRequest.nome = this.subGrupo;

        this._produtoService.adicionarSubGrupo(grupoRequest).subscribe((res) => {
            if (!res.success) return;

            this.atualizerGrupos();
            this.limparForm();
        });
    }

    public deletarsubGrupo(codigo: number) {
        this._produtoService.deletarSubGrupo(codigo).subscribe((res) => {
            if (!res.success) return;
            this.atualizerGrupos();
        });
    }

    public atualizerGrupos() {
        this.subGrupos$ = this._produtoService.getSubGrupos().pipe(map((l) => (l.success ? l.data : [])));
        this.limparForm();
    }

    public limparForm() {
        this.subGrupo = '';
    }
}